export default "__VITE_ASSET__03fdbb64__"